import { combineReducers } from 'redux';
import variants from './Variants';
import { buildings } from './buildings';
import { purchasePolicyReducer } from './v2/purchasePolicy';
import { sharedReducer } from './v2/shared';
import { systemReducer } from './v2/system';
import { verifyPolicyReducer } from './v2/verifyPolicy';

export default combineReducers({
  variants,
  buildings,
  system: systemReducer,
  verifyPolicy: verifyPolicyReducer,
  purchasePolicy: purchasePolicyReducer,
  shared: sharedReducer,
});
